import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, validateUrl } from '../../utils';

export interface PlayAudioOption extends Partial<GeneralInvokeOption> {
  url: string;
}

// 播放音频
export function playAudio(option: PlayAudioOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.Native.PLAY_AUDIO,
      option,
      'parameter error:parameter.url should be String instead of Undefined.'
    );
  }
  if (!validateUrl(option.url)) {
    return logErrorAndRunFail(
      APINames.Native.PLAY_AUDIO,
      option,
      `parameter error: invalid url ${option.url}`
    );
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.PLAY_VOICE, option);
}
